import { ICON_LOGOUT, UPLOAD_IMAGE } from 'app/commons/constants/image.const'
import { isEmpty } from 'app/commons/helpers/compare'
import { compressImage, dataURLtoFile, getQualityImage, showErrorMessage } from 'app/commons/helpers/utils'
import * as Utils from 'app/commons/helpers/utils'
import { editProfile, logout } from 'app/store/auth/authAction'
import { authCreateActions } from 'app/store/auth/authSlice'
import { modalCreateActions } from 'app/store/modal/modalSlice'
import { Formik } from 'formik'

import React, { PureComponent } from 'react'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import PopupConfirm from 'app/components/Common/PopupConfirm'

import { MODAL_TYPES } from '../../commons/constants/modal.const'
import PopupLogout from './PopupLogout/index'
import './style.scss'

const INIT_VALUES = {
  photo: '',
  first_name: '',
  last_name: '',
  phone: '',
  email: '',
  business_name: '',
  password: '',
  new_password: '',
  password_confirmation: '',
  country_code: 'id',
}

const validateProfile = (values) => {
  let { first_name, last_name } = values
  const { password, new_password, password_confirmation } = values
  first_name = first_name ? first_name.trim() : first_name
  last_name = last_name ? last_name.trim() : last_name
  const errors = {}
  if (!first_name) {
    errors.first_name = 'common.editProfile.firstNameRequired'
  }
  if (!last_name) {
    errors.last_name = 'common.editProfile.lastNameRequired'
  }
  if (password) {
    if (new_password) {
      if (password.length < 6) {
        errors.password = 'common.editProfile.currentPasswordLen6'
      }
      if (new_password.length < 6) {
        errors.new_password = 'common.editProfile.newPasswordLen6'
      }
    } else if (!new_password) {
      errors.new_password = 'common.editProfile.newPasswordRequired'
    }
  } else if (new_password) {
    errors.password = 'common.editProfile.passwordRequired'
  }

  if (new_password && new_password !== password_confirmation) {
    errors.password_confirmation = 'common.editProfile.confirmPasswordSameValue'
  }
  return errors
}

class EditProfile extends PureComponent {
  static renderTextError(error, textError, text) {
    if (error) {
      return [<i className="material-icons mr5 Icon b">error</i>, textError]
    }
    return text
  }

  accceptExtensionImage = ['image/jpg', 'image/jpeg', 'image/png', 'image/x-png']

  // unit is bytes
  maxFileSizeAllow = 3145728

  constructor() {
    super()
    this.state = {
      imageUrl: '',
      messageErrorPhoto: '',
      showPassword: false,
      showNewPassword: false,
      showPasswordConfirmation: false,
      showLogoutModal: false,
    }
  }

  processingPhone = (phone) => phone.split('').slice(3).join('')

  toggleShowPassword = (obj) => {
    this.setState((prevState) => ({
      ...prevState,
      [obj]: !prevState[obj],
    }))
  }

  showPassword = (condition) => (condition ? 'green' : 'gray')

  changeTypeInput = (cond) => (cond ? 'input' : 'password')

  submitEditProfile = (values) => {
    const { openModal, editProfile } = this.props
    if (values.new_password === values.password_confirmation) {
      delete values.password_confirmation
      values.first_name = values.first_name ? values.first_name.trim() : values.first_name
      values.last_name = values.last_name ? values.last_name.trim() : values.last_name
      editProfile({
        payload: {
          ...values,
          avatar: this.state.imageFile,
          is_update_avatar: true,
        },
        cb: () => openModal({ typeModal: MODAL_TYPES.USER_PROFILE }),
      })
    }
  }

  handleChangeFileLoaded(event) {
    const file = event.currentTarget.files[0]
    const reader = new FileReader()
    const image = new Image()
    const { t } = this.props
    if (!file) {
      return
    }
    if (!this.accceptExtensionImage.includes(file.type)) {
      this.setState({
        messageErrorPhoto: t('common.editProfile.extensionError'),
      })
      event.target.value = ''
      return
    } else {
      reader.readAsDataURL(file)
      const { name, size } = file
      reader.onloadend = () => {
        image.src = reader.result
        image.onload = () => {
          const compressedImage = compressImage(image, image.width, image.height, getQualityImage(size))
          const newFileResize = dataURLtoFile(compressedImage, name)
          if (newFileResize.size > this.maxFileSizeAllow) {
            this.setState({
              messageErrorPhoto: t('common.editProfile.fileSizeError'),
            })
            return
          } else {
            this.setState({
              imageUrl: reader.result,
              file,
              imageFile: newFileResize,
              messageErrorPhoto: '',
            })
            if (event.target) {
              event.target.value = ''
            }
          }
        }
        image.onerror = () => {
          showErrorMessage('Upload Failed')
        }
      }
    }
  }
  handleConfirmLogout = async () => {
    const { closeModal, logout } = this.props
    logout()
    closeModal()
  }
  renderLogout = () => {
    const { t } = this.props
    return (
      <div className="Edit-Profile__logout">
        <div className="Profile-logout__box" onClick={() => this.setState({ showLogoutModal: true })}>
          <img className="mr10" alt="Logout" height="17" src={ICON_LOGOUT} />
          <span className="default-font">{t('common.editProfile.logOut')}</span>
        </div>
      </div>
    )
  }
  render() {
    const { imageUrl, messageErrorPhoto, showNewPassword, showPassword, showPasswordConfirmation, showLogoutModal } =
      this.state
    const { user, t, errorCurrentPassword, openModal, closeModal, clearErrorMessage } = this.props
    const passwordClass = this.showPassword(showPassword)
    const newPasswordClass = this.showPassword(showNewPassword)
    const passwordConfirmationClass = this.showPassword(showPasswordConfirmation)

    const companyId = Utils.getCompanyId(user)
    const currentEmploy = companyId ? Utils.getCompanyAccount(companyId, user) : {}

    const userProfile = !isEmpty(user)
      ? { ...user, password: '', new_password: '', password_confirmation: '' }
      : INIT_VALUES
    return (
      <>
        <Formik initialValues={userProfile} onSubmit={this.submitEditProfile} validate={validateProfile}>
          {(props) => {
            const { handleSubmit } = props
            return (
              <div className="RightMenu visible Edit-Profile">
                <div className="Edit-Profile-header">
                  <i
                    role="presentation"
                    onClick={() => {
                      openModal({ typeModal: MODAL_TYPES.USER_PROFILE })
                    }}
                    className="material-icons"
                  >
                    arrow_back
                  </i>
                  <span>{t('common.editProfile.editProfile')}</span>
                </div>
                <div className="RightMenu-Box">
                  <form className="Form-Container" onSubmit={handleSubmit}>
                    <div className={`form-group ${messageErrorPhoto && 'Form-Error'}`}>
                      <label className="RightMenu-Box__avatar" htmlFor="photo">
                        <input
                          name="photo"
                          id="photo"
                          type="file"
                          accept={this.accceptExtensionImage.join(',')}
                          onBlur={null}
                          onChange={(event) => this.handleChangeFileLoaded(event)}
                          ref={(fileInput) => {
                            this.fileInput = fileInput
                          }}
                        />
                        <img
                          src={imageUrl || companyId ? currentEmploy?.photo_url : user?.avatar_square}
                          alt="Profile"
                          width="100"
                          height="100"
                        />
                        <div className="RightMenu-avatar__icon">
                          <img alt="Icon Upload" src={UPLOAD_IMAGE} />
                        </div>
                      </label>
                      {this.renderLogout()}
                    </div>
                    {/* First Name */}
                    <div
                      className={`form-group ${props.touched.first_name && props.errors.first_name && 'Form-Error'}`}
                    >
                      <label htmlFor="first_name">
                        {EditProfile.renderTextError(
                          props.touched.first_name && props.errors.first_name,
                          t(props.errors.first_name),
                          t('common.editProfile.firstName')
                        )}
                      </label>
                      <input
                        className="form-control"
                        name="first_name"
                        id="first_name"
                        value={props.values.first_name}
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                      />
                    </div>
                    {/* / First name */}

                    {/* Last Name */}
                    <div className={`form-group ${props.touched.last_name && props.errors.last_name && 'Form-Error'}`}>
                      <label htmlFor="last_name">
                        {EditProfile.renderTextError(
                          props.touched.last_name && props.errors.last_name,
                          t(props.errors.last_name),
                          t('common.editProfile.lastName')
                        )}
                      </label>
                      <input
                        className="form-control"
                        id="last_name"
                        placeholder=""
                        name="last_name"
                        value={props.values.last_name}
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                      />
                    </div>
                    {/* / Last name */}

                    {/* Email */}
                    <div className={`form-group ${props.touched.email && props.errors.email && 'Form-Error'}`}>
                      <label htmlFor="email">
                        {EditProfile.renderTextError(
                          props.touched.email && props.errors.email,
                          'require',
                          t('common.editProfile.email')
                        )}
                      </label>
                      <input
                        className="form-control"
                        name="email"
                        value={props.values.email}
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                        disabled
                      />
                    </div>
                    {/* / Email */}

                    {/* Phone */}
                    <div className={`form-group ${props.touched.phone && props.errors.phone && 'Form-Error'}`}>
                      <label htmlFor="phone">
                        {EditProfile.renderTextError(
                          props.touched.phone && props.errors.phone,
                          'Require',
                          t('common.editProfile.phone')
                        )}
                      </label>
                      <input
                        className="form-control"
                        name="phone"
                        value={props.values.phone}
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                        disabled
                      />
                    </div>
                    {/* / Phone */}

                    {/* Last Name */}
                    <div
                      className={`form-group ${
                        props.touched.business_name && props.errors.business_name && 'Form-Error'
                      }`}
                    >
                      <label htmlFor="business_name">
                        {EditProfile.renderTextError(
                          props.touched.business_name && props.errors.business_name,
                          t(props.errors.business_name),
                          t('common.editProfile.companyName')
                        )}
                      </label>
                      <input
                        className="form-control"
                        id="business_name"
                        placeholder=""
                        name="business_name"
                        value={props.values.business_name}
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                      />
                    </div>
                    {/* / Last name */}

                    {/* Current Passwrod  */}
                    <div
                      className={`form-group ${
                        ((props.touched.password && props.errors.password) || errorCurrentPassword) && 'Form-Error'
                      }`}
                    >
                      <label htmlFor="password">
                        {!errorCurrentPassword &&
                          EditProfile.renderTextError(
                            props.touched.password && props.errors.password,
                            t(props.errors.password),
                            t('common.editProfile.currentPassword')
                          )}
                      </label>
                      <InputGroup className="mb-3">
                        <Form.Control
                          type={this.changeTypeInput(showPassword)}
                          className="form-control no-border-right"
                          name="password"
                          value={props.values.password}
                          onChange={(e) => {
                            props.handleChange(e)
                            errorCurrentPassword && clearErrorMessage()
                          }}
                          onBlur={props.handleBlur}
                        />
                        <InputGroup.Text>
                          <i
                            onClick={() => {
                              this.toggleShowPassword('showPassword')
                            }}
                            role="presentation"
                            className={`material-icons Icon fs18 cur-pointer ${passwordClass}`}
                          >
                            visibility
                          </i>
                        </InputGroup.Text>
                      </InputGroup>
                    </div>
                    {/* / Current Password */}

                    {/* New Passwrod  */}
                    <div
                      className={`form-group ${
                        props.touched.new_password && props.errors.new_password && 'Form-Error'
                      }`}
                    >
                      <label htmlFor="newPassword">
                        {EditProfile.renderTextError(
                          props.touched.new_password && props.errors.new_password,
                          t(props.errors.new_password),
                          t('common.editProfile.newPassword')
                        )}
                      </label>
                      <InputGroup className="mb-3">
                        <Form.Control
                          type={this.changeTypeInput(showNewPassword)}
                          id="newPassword"
                          className="form-control no-border-right"
                          name="new_password"
                          value={props.values.new_password}
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                        />
                        <InputGroup.Text>
                          <i
                            onClick={() => {
                              this.toggleShowPassword('showNewPassword')
                            }}
                            role="presentation"
                            className={`material-icons Icon fs18 cur-pointer ${newPasswordClass}`}
                          >
                            visibility
                          </i>
                        </InputGroup.Text>
                      </InputGroup>
                    </div>
                    {/* / New Password */}

                    {/* Password Confirmation  */}
                    <div
                      className={`form-group ${
                        props.touched.password_confirmation && props.errors.password_confirmation && 'Form-Error'
                      }`}
                    >
                      <label htmlFor="password_confirmation">
                        {EditProfile.renderTextError(
                          props.touched.password_confirmation && props.errors.password_confirmation,
                          t(props.errors.password_confirmation),
                          t('common.editProfile.passwordConfirmation')
                        )}
                      </label>
                      <InputGroup className="mb-3">
                        <Form.Control
                          type={this.changeTypeInput(showPasswordConfirmation)}
                          id="password_confirmation"
                          className="form-control no-border-right"
                          name="password_confirmation"
                          value={props.values.password_confirmation}
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                        />
                        <InputGroup.Text>
                          <i
                            onClick={() => {
                              this.toggleShowPassword('showPasswordConfirmation')
                            }}
                            role="presentation"
                            className={`material-icons Icon fs18 cur-pointer ${passwordConfirmationClass}`}
                          >
                            visibility
                          </i>
                        </InputGroup.Text>
                      </InputGroup>
                    </div>
                    {/* / Password Confirmation */}
                  </form>
                </div>
                <div className="Edit-Profile__action">
                  <button className="btn Button" onClick={() => closeModal()}>
                    {t('common.cancel')}
                  </button>
                  <button type="submit" onClick={handleSubmit} className="btn Button green">
                    {t('common.editProfile.save')}
                  </button>
                </div>
                <div
                  className="RightMenu-close-pane"
                  onClick={() => {
                    closeModal()
                  }}
                />
              </div>
            )
          }}
        </Formik>
        <PopupConfirm
          modalClass="popup-logout"
          useWhiteBackground
          backdrop="static"
          show={showLogoutModal}
          size="lg"
          onClose={() => this.setState({ showLogoutModal: false })}
          onOkClick={this.handleConfirmLogout}
          cancelLabel={t('common.cancel')}
          okLabel={t('common.editProfile.logOut')}
        >
          <PopupLogout />
        </PopupConfirm>
      </>
    )
  }
}

const mapState = (state) => ({
  user: state.auth.login.accounts,
  errorCurrentPassword: state.auth.errorCurrentPassword,
})

const actions = {
  editProfile,
  logout,
  ...modalCreateActions,
  ...authCreateActions,
}

export default withTranslation()(connect(mapState, actions)(EditProfile))
